
import { Navigate, useParams } from "react-router-dom";
import { useClasseContext } from "../context/ClasseContext";
import { useClasse } from "../hooks/fetch_api_hook/useClasse";
import { useGroupe } from "../hooks/fetch_api_hook/useGroupe";
import { useEffect, useState, useMemo } from "react";
import DetailClasse from "./DetailClasse";
import Eleve from "./Eleve";
import Loading from "../components/general/Loading";
import Savoirs from "./Savoirs";
import { useLocation } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { applyRoleResultatsFilter } from "../utils/filtrageResultats";
import { estDemiGroupeVide, classeHorsBarrette, phraseHorsBarrette } from "../utils/groupesDeBesoin";
import SynchronisationGAR from "./SynchronisationGAR";
import ProgressionNiveau from "../components/VueProgression/ProgressionNiveau/ProgressionNiveau";
import ProgressionClasse from "../components/VueProgression/ProgressionClasse/ProgressionClasse";
import ProgressionGroupe from "../components/VueProgression/ProgressionGroupe/ProgressionGroupe";
import PilotageTabs from "../components/general/PilotageTabs";
import { AlertTriangle, ArrowRightLeft, ChevronDown, UserX } from "lucide-react";
function AlerteElevesSansResultats({ eleves, showClasse }) {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className="mb-3 rounded-2xl border border-amber-200 bg-gradient-to-r from-amber-50 to-orange-50 shadow-sm overflow-hidden">
            {/* Header toujours visible */}
            <button
                onClick={() => setExpanded(prev => !prev)}
                className="w-full flex items-center justify-between px-4 py-3 xl:px-5 xl:py-3.5 hover:bg-amber-100/40 transition-colors duration-200"
            >
                <div className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-9 h-9 xl:w-10 xl:h-10 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow-md shadow-amber-200/50">
                        <AlertTriangle className="w-5 h-5 text-white" />
                    </div>
                    <div className="text-left">
                        <p className="text-sm xl:text-base font-bold text-amber-800">
                            {eleves.length} élève{eleves.length > 1 ? "s" : ""} sans résultats
                        </p>
                        <p className="text-xs xl:text-sm text-amber-600/80">
                            Aucune évaluation nationale détectée pour ces élèves
                        </p>
                    </div>
                </div>
                <ChevronDown className={`w-5 h-5 text-amber-500 transition-transform duration-300 ${expanded ? "rotate-180" : ""}`} />
            </button>

            {/* Contenu dépliable */}
            <div className={`transition-all duration-300 ease-out ${expanded ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"} overflow-hidden`}>
                <div className="px-4 pb-4 xl:px-5 xl:pb-5 border-t border-amber-200/60">
                    <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-1.5">
                        {eleves.map((eleve) => (
                            <div key={eleve.id} className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/70 border border-amber-100">
                                <UserX className="w-3.5 h-3.5 text-amber-500 flex-shrink-0" />
                                <span className="text-xs xl:text-sm text-amber-800 font-medium truncate">
                                    {eleve.nom} {eleve.prenom}
                                </span>
                                {showClasse && eleve.classe_nom && (
                                    <span className="ml-auto text-[10px] xl:text-xs text-amber-500 bg-amber-100 rounded-full px-2 py-0.5 flex-shrink-0">
                                        {eleve.classe_nom}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                    <p className="mt-3 text-xs xl:text-sm text-amber-700 bg-amber-100/60 rounded-lg px-3 py-2.5 leading-relaxed">
                        {showClasse
                            ? "Rapprochez-vous du professeur délégué ou des professeurs des classes concernées pour vérifier l'import des résultats."
                            : "Ces élèves étaient peut-être absents aux tests, ou arrivés après. Si leur nom est écrit autrement dans les fichiers du ministère, le chef d'établissement ou le professeur délégué peut redéposer la restitution et le fichier de tests de la classe : les résultats manquants s'ajoutent."
                        }
                    </p>
                </div>
            </div>
        </div>
    );
}

// Membres d'un groupe de besoin partis dans une classe hors de la barrette
// (décision fondateur 2026-10-30) : un constat par élève sous le bandeau, ni
// consigne ni bouton. L'import d'affectation du délégué les sortira du groupe.
function ElevesHorsBarrette({ eleves }) {
    return (
        <div className="mb-3 space-y-1.5">
            {eleves.map((eleve) => (
                <p key={eleve.id} className="flex items-start gap-2 px-4 text-sm text-slate-600">
                    <ArrowRightLeft className="w-4 h-4 mt-0.5 text-slate-400 flex-shrink-0" />
                    <span>{phraseHorsBarrette(`${eleve.nom} ${eleve.prenom}`, eleve.classe_nom)}</span>
                </p>
            ))}
        </div>
    );
}

const DataLoader = ({typeComponent, elevesnat}) => {

    const location = useLocation();
  const savoirfromDashboard = location.state?.savoirfromDashboard;
    const { idclasse } = useParams();
    const { setClasseDetail, classeNom, groupNom } = useClasseContext();
    const [reload,setReload] = useState(false);
   const [messagePost, setMessagePost] = useState('')
   const {user, matiereFilter, resultatsFilter} = useUser();
     const { data: classeData, isLoading: isClasseLoading, isError: isClasseError } = useClasse(idclasse, classeNom==="" && "not-enabled",reload);
    const { data: groupeData, isLoading: isGroupeLoading, isError: isGroupeError } = useGroupe(idclasse+"/", groupNom==="" &&  "not-enabled",reload);

    const classeDetail = classeNom ? classeData : groupeData;

  const filteredClasseDetail = useMemo(
    () => applyRoleResultatsFilter(classeDetail, {
      role: user.role,
      matiereFilter,
      groupNom,
      resultatsFilter,
      filterStudentsByMatiere: true,
    }),
    [classeDetail, matiereFilter, user, groupNom, resultatsFilter],
  );
    const handleReload = () => {
      setReload(!reload)
    }

    const handleMessagePost = (message) =>{
      setMessagePost(message)
    }
        // Filtrer les élèves présents dans classeDetail mais absents dans elevesnat
        // OU présents mais sans résultats de tests spécifiques
  const elevesWithoutEvalNatResults = useMemo(() => {
    // Vérifier que les deux ensembles de données existent et sont valides
    if (
      !classeDetail ||
      !classeDetail.eleves ||
      !elevesnat ||
      !elevesnat.eleves_reponses
    ) {
      return [];
    }

    // Fonction pour vérifier si un élève a des résultats de tests spécifiques
    const hasTestSpecifiqueResults = (eleveReponses) => {
      if (!eleveReponses || !eleveReponses.reponses) return false;

      const reponses = eleveReponses.reponses;

      // Pour maths: vérifier Automatismes ou Problèmes (objets avec Q01, Q02...)
      // Pour français: vérifier Lexique, ComprehensionEcrite, CompetencesLangagieres
      const hasAutomatismes = reponses.Automatismes && typeof reponses.Automatismes === 'object' && Object.keys(reponses.Automatismes).length > 0;
      const hasProblemes = reponses.Problèmes && typeof reponses.Problèmes === 'object' && Object.keys(reponses.Problèmes).length > 0;
      const hasLexique = reponses.Lexique && typeof reponses.Lexique === 'object' && Object.keys(reponses.Lexique).length > 0;
      const hasComprehension = reponses.ComprehensionEcrite && typeof reponses.ComprehensionEcrite === 'object' && Object.keys(reponses.ComprehensionEcrite).length > 0;
      const hasCompetences = reponses['Compétence'] && typeof reponses['Compétence'] === 'object' && Object.keys(reponses['Compétence']).length > 0;

      return hasAutomatismes || hasProblemes || hasLexique || hasComprehension || hasCompetences;
    };

    // Créer une Map des élèves avec leurs réponses pour accès rapide
    const evalNatMap = new Map(
      elevesnat.eleves_reponses.map((e) => [Number(e.id_eleve), e])
    );

    // Retourner les élèves qui :
    // 1. Ne sont pas dans eleves_reponses du tout, OU
    // 2. Sont présents mais n'ont pas de résultats de tests spécifiques
    return classeDetail.eleves.filter((eleve) => {
      // Parti dans une classe hors de la barrette : signalé à part (ElevesHorsBarrette)
      if (classeHorsBarrette(eleve, classeDetail)) return false;

      const eleveReponses = evalNatMap.get(eleve.id);

      // Pas dans la liste du tout
      if (!eleveReponses) return true;

      // Présent mais sans résultats de tests spécifiques
      return !hasTestSpecifiqueResults(eleveReponses);
    });
  }, [classeDetail, elevesnat]);

  // Membres d'un groupe de besoin partis hors de la barrette (aucun pour une classe ou un demi-groupe)
  const elevesHorsBarrette = useMemo(
    () => (classeDetail?.eleves || []).filter((eleve) => classeHorsBarrette(eleve, classeDetail)),
    [classeDetail],
  );

  // Tu peux maintenant utiliser "elevesWithoutEvalNatResults" selon tes besoins

    // ✅ Utiliser useEffect pour mettre à jour l’état après le rendu
    useEffect(() => {
        if (classeDetail) {
            setClasseDetail(classeDetail);
        }
    }, [classeDetail, setClasseDetail]);
// ✅ VÉRIFIER LE LOADING ICI, AVANT LE useMemo
    if(isClasseLoading && classeNom !== ""){
  
        return <Loading loadingText={"Chargement de la classe ..."} />
    }

    if(isGroupeLoading && groupNom !== ""){
        return <Loading loadingText={"Chargement du groupe ..."} />
    }

    if(typeComponent==="dashboard"){
        // Classe vide : l'écran EmptyClassroom SEUL, sans le bandeau d'onglets
        // Pilotage — DetailClasse le rendait en overlay fixed par-dessus les
        // onglets, qui restaient visibles derrière (et le centrage fixed
        // coupait le haut de la carte sur petit écran).
        const estVide = filteredClasseDetail && (!filteredClasseDetail.eleves || filteredClasseDetail.eleves.length === 0);
        if (estVide) {
            // Demi-groupe vide (décision prof 2026-09-30) : rien à piloter, on
            // le compose d'abord, sur la page Élèves.
            if (groupNom && !classeNom && estDemiGroupeVide(filteredClasseDetail)) {
                return <Navigate to={`/home/eleves/${idclasse}`} replace />;
            }
            return <div className="pilotage-enter"><DetailClasse classeDetail={filteredClasseDetail} isClasseLoading={isClasseLoading}
            isGroupeLoading={isGroupeLoading} /></div>;
        }
        return <><PilotageTabs /><div className="pilotage-enter"><DetailClasse classeDetail={filteredClasseDetail} isClasseLoading={isClasseLoading}
        isGroupeLoading={isGroupeLoading} /></div></>;
    }
    else if(typeComponent==='synchronisation'){
      return <SynchronisationGAR classeDetail={filteredClasseDetail} />
    }
    else if(typeComponent==="eleves"){
        return <Eleve eleves={filteredClasseDetail} handleReload={handleReload} handleMessagePost={handleMessagePost} messagePost={messagePost}/>
    }
    else if(typeComponent==="savoirs"){
        return <><PilotageTabs /><div className="pilotage-enter"><Savoirs eleves={filteredClasseDetail} savoirfromDashboard={savoirfromDashboard} /></div></>
    }
    else if(typeComponent==="nationale" && (classeDetail) && (elevesWithoutEvalNatResults.length > 0 || elevesHorsBarrette.length > 0)){
        return (
            <>
                {elevesWithoutEvalNatResults.length > 0 ? <AlerteElevesSansResultats eleves={elevesWithoutEvalNatResults} showClasse={!classeNom} /> : null}
                {elevesHorsBarrette.length > 0 ? <ElevesHorsBarrette eleves={elevesHorsBarrette} /> : null}
            </>
        );
    }
    else if(typeComponent === "progression-commune"){
      return <ProgressionNiveau />;
    }
    else if(typeComponent === "progression-classe"){
      if(classeNom){
        return <><PilotageTabs /><div className="pilotage-enter"><ProgressionClasse /></div></>
      }
      else if(groupNom){
        return <><PilotageTabs /><div className="pilotage-enter"><ProgressionGroupe /></div></>
      }
    }

}

export default DataLoader;